// eslint-disable-next-line import/extensions
import 'inputmask/lib/extensions/inputmask.numeric.extensions.js';
import { createApp, h } from 'vue';
import { createStore } from 'vuex';
import { createRouter, createWebHistory } from 'vue-router';
import VShowSlide from '@ssi/vue-common/src/directives/showSlide';
import FloatingVue from 'floating-vue';
import LocalScope from '@ssi/vue-common/src/components/helpers/LocalScope';
import focus from '@ssi/vue-common/src/directives/focus';
import uniqName from '@ssi/vue-common/src/mixins/uniqName';
import pendingOps from '@ssi/vue-common/src/store/modules/pendingOps';
import ContentCard from './components/ContentCard';
import { formatJsonDate, formatJsonDateTime } from './helpers/dateHelpers';
import InputMask from './plugins/mask';
import NotFound from './views/NotFound';
import 'floating-vue/dist/style.css';

// eslint-disable-next-line import/no-dynamic-require
const config = require(process.env.VUE_APP_CONFIG_PATH).default;

/**
 * Initializes the application with the given root component.
 * @param {Vue Component} rootComponent The root Vue App component.
 * @param {Array} routes Routes for vue-router.
 * @param {Object} opts Other root component initialization options.
 */
export default function init(rootComponent, routes, opts) {
  const app = createApp({
    provide: { config },
    render: () => h(rootComponent),
    ...opts
  });

  app.component('ContentCard', ContentCard);
  app.component('LocalScope', LocalScope);

  app.directive('focus', focus);

  app.mixin(uniqName);

  const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_BASE_URI),
    routes: [
      ...routes,
      { path: '/:pathMatch(.*)*', component: NotFound }
    ]
  });

  const store = createStore({ modules: { pendingOps } });

  app.use(InputMask);
  app.use(VShowSlide);
  app.use(store);
  app.use(router);

  app.use(FloatingVue, {
    themes: {
      'bs-popover': {
        $extend: 'dropdown'
      }
    }
  });

  app.config.globalProperties.$filters = {
    formatCurrency: val => `$${Number(val).toFixed(2)}`,
    formatJsonDate,
    formatJsonDateTime
  };

  app.mount('#app-container');
}
